import { render, staticRenderFns } from "./LPIconText.vue?vue&type=template&id=6841012c"
import script from "./LPIconText.vue?vue&type=script&lang=js"
export * from "./LPIconText.vue?vue&type=script&lang=js"
import style0 from "./LPIconText.vue?vue&type=style&index=0&id=6841012c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports